// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__JiwAaZewsR{display:inline-flex;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationMessageDeliveryStatus/conversationMessageDeliveryStatus.module.scss"],"names":[],"mappings":"AAAA,kBACE,mBAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__JiwAaZewsR`
};
export default ___CSS_LOADER_EXPORT___;
